// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3aY53","overflowing":"ReadFullNote_overflowing__NVxka"};